export enum CreateProjectDirectoryType {
  DEFAULT = 'DEFAULT',
  NEW_PROJEKT_DIR = 'NEW_PROJEKT_DIR',
}
